const locale = {
	USER_DISABLED: 'Access disabled',

	DETAILS_USERS_TAB_ACTIVITIES_KANBAN: 'Activities Kanban',
	DETAILS_USERS_TAB_OPPORTUNITIES_KANBAN: 'Opportunities Kanban',

	// #region User fields
	DETAILS_USERS_FIELD_NAME: 'Name',
	DETAILS_USERS_FIELD_SURNAME: 'Surname',
	DETAILS_USERS_FIELD_MAIL: 'Login Mail',
	DETAILS_USERS_FIELD_RECRUITMENT_DATE: 'Recruitment date',
	DETAILS_USERS_FIELD_BIRTHDAY: 'Birthday',
	DETAILS_USERS_FIELD_ERP_ID: 'NAV Contact Responsible ID',
	DETAILS_USERS_FIELD_ERP_SALESPERSON_ID: 'NAV Salesperson ID',
	DETAILS_USERS_FIELD_HOURLY_RATE: 'Hourly rate',
	DETAILS_USERS_FIELD_ENABLED: 'Enabled',

	DETAILS_USERS_SECTION_USE_EXISTING: 'Use existing user',
	DETAILS_USERS_SECTION_ADD_NEW: 'Add new user',
	DETAILS_USERS_FIELD_PASSWORD: 'Password',
	DETAILS_USERS_FIELD_CONFIRM_PASSWORD: 'Confirm Password',
	DETAILS_USERS_FIELD_FORCE_RESET_PASSWORD: 'Must change password',
	DETAILS_USERS_CHANGE_PASSWORD_TEXT: 'To modify password go to edit mode',
	DETAILS_USERS_FIELD_ROLE: 'User Role',
	// #endregion

	// #region User Avatar
	USERS_AVATAR_SECTION: 'Avatar',
	USERS_AVATAR_SUBHEADER: 'View or update your profile avatar',
	// #endregion

	// #region Details system user creation
	USERS_SYSTEM_USER_CREATION_SECTION: 'Perceptive User Data',
	USERS_SYSTEM_USER_CREATION_SUBHEADER: 'Use an existing Perceptive Suite user or create a new one.',
	// #endregion

	// #region Details user system info
	USERS_APPSETTINGS_SECTION: 'Perceptive Account',
	USERS_APPSETTINGS_SUBHEADER: 'View the Perceptive Account details',
	LOGIN_EMAIL: 'Login Email Address',
	ROLE: 'Role',
	LAST_LOGIN: 'Last login',
	PASSWORD: 'Password',
	LOGIN_EMAIL_EDIT_BUTTON: 'Edit Login Mail',

	DETAILS_USERS_STATUS_TITLE: 'Status',
	DETAILS_USERS_STATUS_ACTIVE: 'ACTIVE',
	DETAILS_USERS_STATUS_DISABLED: 'DISABLED',
	// #endregion

	// #region Change Login Mail Dialog
	DIALOG_LOGIN_MAIL_TITLE: 'Edit Login Mail',
	DIALOG_LOGIN_MAIL_DESCRIPTION1: 'Use the "Mail" field to edit the login mail',
	DIALOG_LOGIN_MAIL_DESCRIPTION2: 'Warning! The login address will be modified for each Perceptive App.',
	DIALOG_LOGIN_EMAIL_FIELD: 'Mail',
	// #endregion

	// #region User's integrations
	USERS_INTEGRATION_MAILCHIMP_SECTION: 'Mailchimp Account',
	USERS_INTEGRATION_MAILCHIMP_SUBHEADER: 'View your Mailchimp account info',

	USERS_INTEGRATION_MAILUP_SECTION: 'Mailup Account',
	USERS_INTEGRATION_MAILUP_SUBHEADER: 'View your Mailup account info',
	// #endregion

	// #region Details User Permissions section
	USERS_PERMISSIONS_SECTION: 'Application Permissions',
	USERS_PERMISSIONS_SUBHEADER: 'View and edit the application permissions',
	NOT_SUPPORTED: 'Setting not supported by the browser',
	PUSH_NOTIFICATIONS_SETTING: 'Push notifications',
	SPEECH_TO_TEXT_SETTING: 'Speech To Text',
	MAIL_NOTIFICATION_SETTING: 'Mail notifications',
	// #endregion

	// #region Details User Saved Filters section
	USERS_SAVEDFILTERS_SECTION: 'Saved filters',
	USERS_SAVEDFILTERS_SUBHEADER: "View the User's saved filters",
	// #endregion

	// #region Settings Mailchimp user account details
	SETTINGS_USER_ACCOUNT_MAILCHIMP_MEMBER_SINCE: 'Member since: {date}',
	SETTINGS_USER_ACCOUNT_MAILCHIMP_SUBSCRIBERS: 'Subscribers: {subscribers} / {tot}',
	SETTINGS_USER_ACCOUNT_MAILCHIMP_PLAN: 'Plan Type: {type}',
	// #endregion

	// #region Settings Mailup user account details
	SETTINGS_USER_ACCOUNT_MAILUP_EXPIRY_DATE: 'Expiry date: {date}',
	// #endregion

	// #region User Daily Report
	USERS_DAILYREPORT_SECTION: 'Daily mail report',
	USERS_DAILYREPORT_SUBHEADER: 'Activate/deactivate the daily mail report',

	DIALOG_TITLE_DAILY_REPORT_SETTINGS: 'Daily mail report settings',
	DAILY_REPORT_FIELD_TEMPLATE: 'Template name',
	DAILY_REPORT_FIELD_CRON: 'Cron',

	DAILY_REPORT_TEMPLATE: 'Template: {template}',
	DAILY_REPORT_TYPE: 'Type: {type}',
	DAILY_REPORT_CREATEDAT: 'Creation at {date}',
	DAILY_REPORT_NEXTEXECUTION: 'Next execution at {date}',
	DAILY_REPORT_RECURRENCE: 'Recurrence: "{cron}"',

	DAILY_REPORT_UNIT_WEEK: 'weeks',
	DAILY_REPORT_UNIT_DAY: 'days',
	DAILY_REPORT_UNIT_HOUR: 'hours',
	DAILY_REPORT_UNIT_MINUTE: 'minutes',
	// #endregion

	USER_LOGIN_LOGS: 'Login logs'
};

export default locale;
